import(/* webpackMode: "eager" */ "/vercel/path0/app/lessons/test-room/page.tsx");
